<template>
  <div class="widget-notification">
    <div class="widget-notification__wrapper">
      <v-alert :type="notificationType" :color="themeColors.secondary">{{ message }} </v-alert>
    </div>
  </div>
</template>

<script lang="ts">
import { app } from "@/main";

export default {
  name: "WidgetNotification",

  props: {
    message: String,
    notificationType: {
      default: "info",
      type: String,
    },
  },

  data() {
    return {
      themeColors: app.$vuetify.theme.currentTheme,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/custom_variables.scss";

.widget-notification {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 50px;
  color: red;
}

.widget-notification__wrapper {
  border-radius: $border-radius-x-small !important;
  padding: 16px 24px;
  margin-bottom: 0;
  .v-alert {
    margin-bottom: 0;
  }
  .mdi-alert {
    margin-bottom: 3px;
  }
}

.theme--light .widget-notification__wrapper {
  background-color: var(--v-secondary-base) !important;
  ::v-deep * {
    color: var(--v-content-light-base) !important;
    caret-color: var(--v-content-light-base) !important;
  }
}

.theme--dark .widget-notification__wrapper {
  background-color: var(--v-secondary-base) !important;

  ::v-deep * {
    color: var(--v-content-dark-base) !important;
    caret-color: var(--v-content-dark-base) !important;
  }
}
::v-deep .v-alert {
  padding: 0;
}
</style>
